import { render, staticRenderFns } from "./item-info-sizes.vue?vue&type=template&id=083faf05&scoped=true"
import script from "./item-info-sizes.vue?vue&type=script&lang=js"
export * from "./item-info-sizes.vue?vue&type=script&lang=js"
import style0 from "./item-info-sizes.vue?vue&type=style&index=0&id=083faf05&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083faf05",
  null
  
)

export default component.exports